/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { init as sentryInit, browserTracingIntegration } from '@sentry/angular';
import { environment } from './environments/environment';
import posthog from 'posthog-js';

posthog.init('phc_BnQ5qK4o2P6VYmJr6tsELPFhDBzjaxC7yYiyVRsveAQ4', {
    api_host: 'https://us.i.posthog.com',
    defaults: "2026-01-30",
    capture_performance: false,
    disable_surveys: true
});
posthog.register({
    project: "cfa"
})

if (environment.prod) {
    sentryInit({
        dsn: environment.sentryKey,
        sendDefaultPii: true,
        // // sentry tracing disabled
        // integrations: [browserTracingIntegration()],
        // tracesSampleRate: 0.2,
        // tracePropagationTargets: ["https://crewfiction.com/api"]
    });
}
bootstrapApplication(AppComponent, appConfig)
    .catch((err) => console.error(err));
